<template>
  <div>
    <el-table
        :data="processedTableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa' }">

      <!-- 表格列定义 -->
      <el-table-column align="center" prop="i" label="序号" width="50" />
      <el-table-column align="center" prop="notaryNo" label="卷宗号" />
      <el-table-column align="center" prop="dsr" label="当事人" />
      <el-table-column align="center" prop="dsrPhone" label="联系电话" />
      <el-table-column align="center" prop="itemName" label="公证事项" />
      <el-table-column align="center" prop="itemType" label="公证类别" />
      <el-table-column align="center" prop="createTime" label="申请日期" />
      <el-table-column align="center" prop="status_name" label="流程状态" width="120" />

      <!-- 操作列 -->
      <el-table-column align="center" fixed="right" label="操作" width="350">
        <template slot-scope="scope">
          <!-- 使用flex布局确保按钮在同一行 -->
          <div class="action-buttons">
            <!-- 执行类案件操作 (STATUS > 6) -->
            <div v-if="scope.row.STATUS > 6" class="button-group">
              <el-button
                  v-if="scope.row.executionType == 1"
                  type="primary"
                  size="small"
                  @click="openZhiXingDialog('edit', scope.row.id, scope.row.executionType, 'heshihan')">
                开始核实
              </el-button>

              <el-button
                  v-if="scope.row.executionType == 2"
                  type="primary"
                  size="small"
                  @click="openZhiXingDialog('edit', scope.row.id, scope.row.executionType, 'chuzheng')">
                开始强执
              </el-button>

              <el-button
                  type="primary"
                  size="small"
                  @click="callVideo(scope.row.id)">
                视频连线
              </el-button>

              <el-button
                  type="danger"
                  size="small"
                  @click="$refs.noPass.open(scope.row.id, scope.row.STATUS)">
                不予受理
              </el-button>
            </div>

            <!-- 普通案件操作 (STATUS <= 6) -->
            <div v-else class="button-group">
              <!-- 主操作按钮 -->
              <el-button
                  v-if="[1,2,3,4,-2,5,6,7].includes(scope.row.STATUS)"
                  type="primary"
                  size="small"
                  @click="handleMainAction(scope.row)">
                {{ getMainButtonText(scope.row.STATUS) }}
              </el-button>

              <!-- 公共按钮 -->
              <el-button
                  type="primary"
                  size="small"
                  @click="callVideo(scope.row.id)">
                视频连线
              </el-button>

              <el-button
                  type="danger"
                  size="small"
                  @click="$refs.noPass.open(scope.row.id, scope.row.STATUS)">
                不予受理
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
        class="my-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="pageNum"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" />

    <!-- 弹窗组件 -->
    <CaseInfo
        :openType="openType"
        :currCaseId="currCaseId"
        ref="caseInfo"
        @checkSuccess="createSuccess"
        @createSuccess="createSuccess"
        @noPass="handleNoPass" />

    <CaseZhiXingInfo
        :openType="openType"
        :currCaseId="currCaseId"
        ref="caseZhiXingInfo"
        @checkSuccess="createSuccess"
        @createSuccess="createSuccess" />

    <!-- 初审弹窗 -->
    <FristExamine :currCaseId="currCaseId" ref="fristExamine" />

    <!-- 确认受理 -->
    <AcceptanceDialog :currCaseId="currCaseId" ref="acceptanceDialog" />

    <!-- 证件材料 -->
    <Evidence ref="evidence" />

    <!-- 拟定证书 -->
    <CreateDoc ref="createDoc" />

    <!-- 不予通过弹窗 -->
    <NoPass ref="noPass"  @success="handleNoPassSuccess" @checkSuccess="createSuccess" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { myConfirm, conVertDate, randomNum } from "@/utils/tools";
import CaseInfo from "./case-info";
import FristExamine from "./dialog/frist-examine-dialog.vue";
import AcceptanceDialog from "./dialog/acceptance-dialog";
import Evidence from "./dialog/evidence-dialog";
import eventVue from "./event.js";
import CreateDoc from "./dialog/create-document-dialog";
import NoPass from "./dialog/no-pass";
import config from "../../../config";
import DES from "../../../utils/des";
import CaseZhiXingInfo from './case-zhixing-info.vue';

export default {
  components: {
    CaseInfo,
    FristExamine,
    AcceptanceDialog,
    Evidence,
    CreateDoc,
    NoPass,
    CaseZhiXingInfo
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      openType: "see",
      currCaseId: null,
      loading: true,
      queryData: {},
    };
  },
  computed: {
    ...mapGetters({
      gzItems: "enum/gzItems",
      userInfo: "login/userInfo",
    }),

    // 处理后的表格数据
    processedTableData() {
      return this.tableData.map((item, index) => {
        // 添加序号
        item.i = index + 1 + (this.pageNum - 1) * this.pageSize;

        // 格式化日期
        item.createTime = conVertDate(item.createTime, false);

        // 设置状态名称
        item.status_name = this.getStatusName(item);

        return item;
      });
    }
  },
  mounted() {
    eventVue.$on("openEvidence", () => {
      this.$refs.evidence.open();
    });
    eventVue.$on("openFristExamine", () => {
      this.$refs.fristExamine.open();
    });
    eventVue.$on("submit", (data) => {
      this.queryData = data;
      this.getList(data);
    });
    eventBus.$on("eventOpenDialog", (data) => {
      this.$refs.caseInfo.close();
      this.openDialog(data.type, data.id);
    });
    eventBus.$on("getMessage", () => {
      this.getList();
    });
    eventBus.$on("checkSuccess", () => {
      this.getList();
    });
    if (this.$route.query.type) {
      this.openDialog(this.$route.query.type, this.$route.query.id);
      this.$route.query.type = "";
      this.getList();
    }

    this.getList();
  },
  methods: {
    // 获取主操作按钮文本
    getMainButtonText(status) {
      const statusTextMap = {
        1: "开始初核",
        2: "开始受理",
        3: "开始审查",
        4: "开始审批",
        [-2]: "开始拟词",
        5: "开始出证",
        6: "开始发证"
      };
      return statusTextMap[status] || "操作";
    },

    // 处理主操作按钮点击
    handleMainAction(row) {
      if (row.STATUS === 1) {
        this.openDialog('edit', row.id, row.notaryNo, 'heshihan');
      } else {
        this.openDialog('edit', row.id, row.notaryNo);
      }
    },

    // 获取状态名称
    getStatusName(item) {
      if (item.STATUS > 6) {
        switch (item.executionType) {
          case 1: return "申请执行";
          case 2: return "核实中";
          case 3: return "已出执行";
          case 4: return "执行驳回";
          default: return "";
        }
      } else {
        switch (item.STATUS) {
          case -2: return "拟定公证书";
          case -1: return "不予受理";
          case 1: return "等待初核";
          case 2: return "等待受理";
          case 3: return "等待审查";
          case 4: return "等待审批";
          case 5: return "等待制证";
          case 6: return "等待发证";
          case 7: return "等待归档";
          case 8: return "等待收费";
          default: return "";
        }
      }
    },

    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList({ ...this.queryData });
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList({ ...this.queryData });
    },

    handleNoPass(id, status) {
      this.$refs.noPass.open(id, status);
    },
    handleNoPassSuccess(payload) {
      console.log('不予受理操作成功，刷新列表', payload)
      this.getList()
    },

    // 打开普通案件弹窗
    openDialog(type, id, notaryNo, action) {
      if (type === "add") {
        this.$store.commit("case/updateCaseInfo", {});
        this.$store.commit("case/clearPersonList");
        this.$store.commit("case/clearNotaryDocumentList");
        if (notaryNo) {
          this.$store.commit("case/updateNotaryNo", notaryNo);
        }
      }

      this.currCaseId = id;
      this.openType = type || "see";
      this.$refs.caseInfo.open();
      this.$refs.caseInfo.getCaseDetails(id);
    },

    // 打开执行案件弹窗
    openZhiXingDialog(type, id, executionType, action) {
      if (type === "add") {
        this.$store.commit("case/updateCaseInfo", {});
        this.$store.commit("case/clearPersonList");
        this.$store.commit("case/clearNotaryDocumentList");
      }

      this.currCaseId = id;
      this.$store.commit("makeCard/updateChuzhengId", id);
      if (action) {
        this.$store.commit("makeCard/updateAction", action);
      }

      this.openType = type || "see";
      this.$refs.caseZhiXingInfo.getCaseDetails(id);
      this.$refs.caseZhiXingInfo.open(executionType);
    },

    // 案件操作成功回调
    createSuccess() {
      this.getList();
    },

    // 获取案件列表
    getList(data) {
      this.loading = true;
      this.$api.caseListMy({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...data,
      }).then((res) => {
        if (res.data.code === "200") {
          this.total = res.data.data.total ? parseInt(res.data.data.total) : 0;
          this.tableData = res.data.data.records || [];
        }
      }).finally(() => {
        this.loading = false;
      });
    },

    // 视频通话
    async callVideo(id) {
      const sendMsg = () => {
        let roomId = randomNum(1, 9999);
        let url = config.callVideoUrl;
        let date = DES.encryptBy(new Date().getTime().toString());
        date = encodeURIComponent(date);
        let adminCallUrl = `${url}?username=${id},${this.userInfo.username}&d=${date}&roomId=${roomId}&userType=admin`;
        let userCallUrl = `${url}?username=${id}&d=${date}&roomId=${roomId}&notary=${this.userInfo.username}&userType=user`;

        this.$api.sendMsgToUser({
          contractId: id,
          videoUrl: userCallUrl,
          flag: 0,
        }).then((res) => {
          if (res.data.code === "200") {
            window.open(adminCallUrl, "_blank");
          }
        });
      };

      this.$confirm("发起视频连线前,请先于当事人电话沟通。", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          this.$confirm(
              "请确保您的电脑有摄像头和麦克风。否则可能会发起失败！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
          ).then(() => {
            sendMsg();
          });
        } else {
          let devices = await navigator.mediaDevices.enumerateDevices();
          let hasCamera = devices.some(d => d.kind === 'videoinput');
          let hasMicrophone = devices.some(d => d.kind === 'audioinput');

          if (!hasCamera) {
            this.$alert("当前设备未检查到摄像头，无法发起视频连线！", "提示", {
              confirmButtonText: "确定",
              type: "error",
            });
            return;
          }

          if (!hasMicrophone) {
            this.$alert("当前设备未检查到麦克风，无法发起视频连线！", "提示", {
              confirmButtonText: "确定",
              type: "error",
            });
            return;
          }

          sendMsg();
        }
      });
    }
  }
};
</script>

<style scoped>
.my-pagination {
  margin-top: 20px;
  text-align: right;
}

.add-case-btn {
  margin-bottom: 10px;
}

/* 操作按钮布局优化 */
.action-buttons {
  display: flex;
  justify-content: center;
}

.button-group {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px; /* 按钮间距 */
}

/* 按钮尺寸优化 */
.el-button {
  padding: 7px 9px;
  font-size: 12px;
  min-width: 72px;
}
</style>